<template>
    <div style="height: 100%; margin: auto">
        <div class="logo-on-top">
            <v-img
                contain
                position="top center"
                max-height="56px"
                max-width="200px"
                src="/img/logo.png"
            ></v-img>
        </div>
        <div class="map-style" ref="map"></div>
        <v-dialog
            v-model="showDialog"
            persistent
            width="400"
            :content-class="isSlidingRadius ? 'geofence-dialog geofence-dialog--sliding' : 'geofence-dialog'"
            style="top: -200px"
        >
            <v-card
                :class="{ 'geofence-slider-only': isSlidingRadius }"
                :style="{ backgroundColor: isSlidingRadius ? 'transparent' : '#ffffff' }"
            >
                <v-card-title v-if="!isSlidingRadius">
                    <span class="headline">Geofence Settings</span>
                </v-card-title>
                <v-card-text :class="{ 'py-4': isSlidingRadius, 'pb-2': !isSlidingRadius }">
                    <v-row>
                        <v-col cols="12">
                            <div class="d-flex flex-column">
                                <div>
                                    <div
                                        class="text-caption"
                                        :class="{ 'text-center subtitle-2 font-weight-medium mb-2': isSlidingRadius }"
                                    >
                                        Geofence radius
                                    </div>
                                    <v-slider
                                        :value="profile.geofenceRadius"
                                        prepend-icon="mdi-map-marker-radius"
                                        :hide-details="isSlidingRadius"
                                        :step="5"
                                        min="25"
                                        max="250"
                                        @mousedown.native="isSlidingRadius = true"
                                        @touchstart.native="isSlidingRadius = true"
                                        @input="onRadiusSliderInput"
                                        @mouseup.native="isSlidingRadius = false"
                                        @touchend.native="isSlidingRadius = false"
                                        @touchcancel.native="isSlidingRadius = false"
                                        @mouseleave.native="isSlidingRadius = false"
                                        @change="onRadiusSliderChange"
                                    >
                                        <template v-slot:append>
                                            <div class="slider-label" :class="{ 'font-weight-bold': isSlidingRadius }">
                                                {{
                                                    profile.geofenceRadius
                                                }}
                                                meters
                                            </div>
                                        </template>
                                    </v-slider>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    <v-checkbox
                        v-show="!isSlidingRadius"
                        v-model="showGeofence"
                        :disabled="armed"
                        label="Show geofence when disarmed"
                        @change="updateGeoFenceVisible"
                    ></v-checkbox>
                    <v-checkbox
                        v-show="!isSlidingRadius"
                        v-model="profile.geofenceSirenEnabled"
                        label="Trigger siren on geofence breach"
                    ></v-checkbox>
                </v-card-text>
                <v-card-actions v-show="!isSlidingRadius">
                    <v-spacer></v-spacer>
                    <v-btn @click="closeGeofenceDialog">Cancel</v-btn>
                    <v-btn color="success" @click="saveGeofence">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-speed-dial v-model="fab2" bottom left>
            <template v-slot:activator>
                <v-tooltip right color="blue darken-1" v-model="showSettings">
                    <template #activator="data">
                        <v-btn
                            color="blue darken-1"
                            fab
                            large
                            dark
                            bottom
                            left
                            v-bind="data.attrs"
                            @click.stop="showGeofenceDialog"
                        >
                            <v-icon>mdi-map-marker-radius</v-icon>
                        </v-btn>
                    </template>
                    <span>GEOFENCE</span>
                </v-tooltip>
            </template>
        </v-speed-dial>

        <LoadingDialog
            v-model="isFetchingPosition"
            message="OBTAINING POSITION ..."
        />

        <v-speed-dial
            v-model="fab"
            bottom
            right
            :direction="direction"
            :open-on-hover="hover"
            :transition="transition"
        >
            <template v-slot:activator>
                <v-badge
                    bordered
                    :value="isLoading"
                    color="indigo"
                    icon="mdi-map-marker-path"
                    overlap
                >
                    <v-tooltip left color="indigo darken-4" v-model="showThief">
                        <template #activator="data">
                            <v-btn
                                v-model="fab"
                                color="indigo darken-4"
                                dark
                                large
                                fab
                                v-bind="data.attrs"
                                @click="showThief = !showThief"
                            >
                                <v-icon v-if="fab"> mdi-close </v-icon>
                                <v-icon v-else> mdi-car-emergency </v-icon>
                            </v-btn>
                        </template>
                        <span>CATCH THE THIEF !</span>
                    </v-tooltip>
                </v-badge>
            </template>

            <v-tooltip left color="red" v-model="showTTs">
                <template #activator="data">
                    <v-btn
                        fab
                        dark
                        color="red"
                        :disabled="!isLoading"
                        v-bind="data.attrs"
                        @click.stop="stop_tracking"
                    >
                        <v-icon>mdi-stop</v-icon>
                    </v-btn>
                </template>
                <span>STOP TRACKING</span>
            </v-tooltip>
            <v-tooltip left color="indigo" v-model="showTTs">
                <template #activator="data">
                    <v-btn
                        fab
                        dark
                        color="indigo"
                        v-bind="data.attrs"
                        @click.stop="updateShipPosition"
                    >
                        <v-icon>mdi-map-search</v-icon>
                    </v-btn>
                </template>
                <span>LATEST BOAT POSITION</span>
            </v-tooltip>
            <v-tooltip left color="green" v-model="showTTs">
                <template #activator="data">
                    <v-btn
                        fab
                        dark
                        :loading="isLoading"
                        :disabled="isLoading"
                        color="green"
                        v-bind="data.attrs"
                        @click.stop="start_tracking"
                    >
                        <v-icon>mdi-map-marker-path</v-icon>
                    </v-btn>
                </template>
                <span>START TRACKING</span>
            </v-tooltip>
        </v-speed-dial>
    </div>
</template>
<script lang="ts">
import {
    defineComponent,
    getCurrentInstance,
    onMounted,
    onUnmounted,
    onBeforeUnmount,
    nextTick,
    ref,
    watch,
    computed,
} from "vue";
import useMap from "@/utilities/useGoogleMaps";
import {
    MANUAL_GEOLOCATION_OPTIONS,
    TRACKING_GEOLOCATION_OPTIONS,
    getGeolocationErrorMessage,
    getGeolocationUnavailableMessage,
    isGeolocationPermissionDenied,
    requestCurrentPosition,
    resolveGeolocationAccess,
    startWatchingPosition,
    stopWatchingPosition,
} from "@/utilities/useGeolocation";
import { alarm, app } from "@/store";
import { profile as profilestore } from "@/store/index";
import ProfileViewModel from "@/models/ProfileViewModel";
import moment from "moment-timezone";

export default defineComponent({
    name: "MapView",
    components: {
        LoadingDialog: () =>
            import("./components/Dialogs/LoadingDialog.vue"),
    },
    setup() {
        const root = getCurrentInstance()?.proxy as any;
        const GOOGLE_MAP_ID = process.env.VUE_APP_GOOGLE_MAPS_MAP_ID || "DEMO_MAP_ID";
        const map = ref();
        const { googleMapApi } = useMap();
        const location = ref<GeolocationPosition>();
        type AdvancedMarker = google.maps.marker.AdvancedMarkerElement;
        type ManagedAdvancedMarker = AdvancedMarker & {
            __gmpClickHandler?: EventListener;
        };
        type ImageMarkerConfig = {
            url: string;
            width: number;
            height: number;
            alt: string;
        };
        let myGoogleMap: google.maps.Map;
        let shipMarker: AdvancedMarker;
        let userMarker: AdvancedMarker;
        let geoFence: google.maps.Circle;
        let geoFenceDisarmed: google.maps.Circle;
        let shipIcon: ImageMarkerConfig;
        let userIcon: ImageMarkerConfig;
        let user: google.maps.LatLng;
        let ship: google.maps.LatLng;
        let infoWindow: google.maps.InfoWindow;
        let infoWindowBoat: google.maps.InfoWindow;
        let timer: any;
        let timerBoat: any;
        let userPositionWatchId: number | null = null;
        let stopArmedWatch: Function | null = null;
        let stopLastKnownLocationWatch: Function | null = null;
        let showDialog = ref<boolean>(false);
        let showGeofence = ref<boolean>(true);
        const isSlidingRadius = ref<boolean>(false);
        const isFetchingPosition = ref<boolean>(false);
        const isCatchThiefActive = ref<boolean>(false);
        let unsavedGeofenceRadius: number;
        const errorMessage = ref<string>("");

        const warnMap = (message: string, extra?: unknown) => {
            console.warn(`[MapView] ${message}`, extra ?? "");
        };

        const patchIntersectionObserver = () => {
            const scopedWindow = window as Window & {
                __marineOneObserverPatched?: boolean;
            };

            if (
                scopedWindow.__marineOneObserverPatched ||
                !("IntersectionObserver" in window)
            ) {
                return;
            }

            const originalObserve = window.IntersectionObserver.prototype.observe;
            window.IntersectionObserver.prototype.observe = function(target: Element) {
                if (!(target instanceof Element)) {
                    warnMap("IntersectionObserver target was invalid, skipping observe");
                    return;
                }

                return originalObserve.call(this, target);
            };

            scopedWindow.__marineOneObserverPatched = true;
        };

        const stopSlidingRadius = () => {
            isSlidingRadius.value = false;
        };

        const clearTrackingTimers = () => {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }

            if (userPositionWatchId !== null) {
                stopWatchingPosition(userPositionWatchId);
                userPositionWatchId = null;
            }

            if (timerBoat) {
                clearInterval(timerBoat);
                timerBoat = null;
            }
        };

        const cleanupPageResources = () => {
            window.removeEventListener("mouseup", stopSlidingRadius);
            window.removeEventListener("touchend", stopSlidingRadius);
            window.removeEventListener("touchcancel", stopSlidingRadius);
            clearTrackingTimers();

            if (stopArmedWatch) {
                stopArmedWatch();
                stopArmedWatch = null;
            }

            if (stopLastKnownLocationWatch) {
                stopLastKnownLocationWatch();
                stopLastKnownLocationWatch = null;
            }
        };

        const onRadiusSliderChange = () => {
            stopSlidingRadius();
            updateGeoFenceRadius();
        };

        const onRadiusSliderInput = (value: number | string) => {
            const radius = typeof value === "number" ? value : parseFloat(value);
            if (Number.isNaN(radius)) {
                warnMap("slider input ignored because radius was invalid", value);
                return;
            }

            profile.value.geofenceRadius = radius;
        };

        // === NEW helpers for nice InfoWindows with local time ===
        const userTZ = ref<string>(
            Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
        );
        const formatLocal = (
            ts: number | string,
            fmt = "YYYY-MM-DD HH:mm:ss z"
        ) =>
            (typeof ts === "number" ? moment(ts) : moment.utc(ts))
                .tz(userTZ.value)
                .format(fmt);

        const infoCard = (
            title: string,
            rows: Array<[string, string | number]>
        ) => `
  <div style="
    font-family: system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;
    color:#fff; background:#0b132b; border-radius:12px;
    min-width:260px; max-width:340px; overflow:hidden;">
    <div style="padding:10px 36px 10px 12px; font-weight:600; font-size:14px;">
      ${title}
    </div>
    <div style="padding:10px 12px; background:rgba(255,255,255,.04)">
      ${rows
          .map(
              ([k, v]) => `
        <div style="display:flex; justify-content:space-between; gap:12px; padding:6px 0; border-bottom:1px solid rgba(255,255,255,.08)">
          <div style="opacity:.8">${k}</div>
          <div style="font-weight:600">${v}</div>
        </div>
      `
          )
          .join("")}
    </div>
  </div>
`;

        const createImageMarkerContent = (icon: ImageMarkerConfig): HTMLDivElement => {
            const wrapper = document.createElement("div");
            wrapper.style.width = `${icon.width}px`;
            wrapper.style.height = `${icon.height}px`;
            wrapper.style.display = "flex";
            wrapper.style.alignItems = "center";
            wrapper.style.justifyContent = "center";

            const img = document.createElement("img");
            img.src = icon.url;
            img.alt = icon.alt;
            img.width = icon.width;
            img.height = icon.height;
            img.draggable = false;
            img.style.width = "100%";
            img.style.height = "100%";
            img.style.objectFit = "contain";
            img.style.pointerEvents = "none";
            img.style.userSelect = "none";

            wrapper.appendChild(img);
            return wrapper;
        };

        const createAdvancedMarker = (options: {
            position: google.maps.LatLng | google.maps.LatLngLiteral;
            icon: ImageMarkerConfig;
            title: string;
            visible?: boolean;
            zIndex?: number;
            clickable?: boolean;
        }): AdvancedMarker => {
            return new google.maps.marker.AdvancedMarkerElement({
                map: options.visible === false ? null : myGoogleMap,
                position: options.position,
                content: createImageMarkerContent(options.icon),
                title: options.title,
                zIndex: options.zIndex,
                gmpClickable: options.clickable ?? false,
            });
        };

        const setMarkerVisible = (marker: AdvancedMarker, visible: boolean) => {
            marker.map = visible ? myGoogleMap : null;
        };

        const setMarkerPosition = (
            marker: AdvancedMarker,
            position: google.maps.LatLng | google.maps.LatLngLiteral
        ) => {
            marker.position = position;
        };

        const getMarkerPosition = (marker: AdvancedMarker): google.maps.LatLng => {
            if (marker.position instanceof google.maps.LatLng) {
                return marker.position;
            }

            if (marker.position) {
                return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }

            throw new Error("Marker position is not set.");
        };

        const openInfoWindowAtMarker = (
            currentInfoWindow: google.maps.InfoWindow,
            marker: AdvancedMarker
        ) => {
            currentInfoWindow.open({
                map: myGoogleMap,
                anchor: marker,
                shouldFocus: false,
            });
        };

        const setMarkerClickHandler = (
            marker: AdvancedMarker,
            handler: () => void
        ) => {
            const managedMarker = marker as ManagedAdvancedMarker;
            if (managedMarker.__gmpClickHandler) {
                managedMarker.removeEventListener("gmp-click", managedMarker.__gmpClickHandler);
            }

            const listener: EventListener = () => handler();
            managedMarker.__gmpClickHandler = listener;
            managedMarker.addEventListener("gmp-click", listener);
        };

        const emptyProfile: ProfileViewModel = {
            userId: "",
            deviceId: "",
            shipName: "",
            shipHomeLocation: "",
            boatImage: "",
            geofenceRadius: 0,
            geofenceSirenEnabled: true,
            geofenceLatitude: 0,
            geofenceLongitude: 0,
            isCaptain: false,
            isApproved: false,
            hasGalleryAccess: false,
            hasUploadAccess: false,
            isPaid: false,
            mBsUsed: 0,
            dataLimit: 0,
            transactionsUsed: 0,
            transactionsLimit: 0,
            billingStart: "",
            billingEnd: "",
        };

        const profile = computed<ProfileViewModel>(() => {
            return profilestore.profile ?? emptyProfile;
        });

        const geoFenceRadius = computed<number>(() => {
            return profile.value.geofenceRadius;
        });

        const lat = computed<number>(() => {
            return alarm.lat ? alarm.lat : 0;
        });

        const lng = computed<number>(() => {
            return alarm.lng ? alarm.lng : 0;
        });

        const user_lat = computed<number>(() => {
            return alarm.user_lat ? alarm.user_lat : 0;
        });

        const user_lng = computed<number>(() => {
            return alarm.user_lng ? alarm.user_lng : 0;
        });

        const geofence_lat = computed<number>(() => {
            return profile.value.geofenceLatitude ?? 0;
        });

        const geofence_lon = computed<number>(() => {
            return profile.value.geofenceLongitude ?? 0;
        });

        const latLetter = computed<string>(() => (lat.value >= 0 ? "N" : "S"));

        const lngLetter = computed<string>(() => (lng.value >= 0 ? "E" : "W"));

        const toggle = (isArmed: boolean) => {
            if (!geoFence || !geoFenceDisarmed) {
                warnMap("toggle skipped because geofence is not initialized");
                return;
            }
            geoFence.setVisible(isArmed); // red circle when armed
            geoFenceDisarmed.setVisible(!isArmed && showGeofence.value); // green circle when disarmed
        };

        const requestUserPosition = async (
            showLoading: boolean = true,
            options: PositionOptions = MANUAL_GEOLOCATION_OPTIONS
        ): Promise<GeolocationPosition | null> => {
            if (showLoading && !isCatchThiefActive.value) {
                isFetchingPosition.value = true;
            }

            try {
                const position = await requestCurrentPosition(options);
                handlePositionSuccess(position);
                return position;
            } catch (error) {
                if (error instanceof Error) {
                    isFetchingPosition.value = false;
                    errorMessage.value = error.message || getGeolocationUnavailableMessage();
                    app.error = errorMessage.value;
                    return null;
                }

                await handlePositionError(error as GeolocationPositionError);
                return null;
            }
        };

        const handlePositionSuccess = (position: GeolocationPosition) => {
            // Only hide loading if we're not in catch thief mode or if it was explicitly shown
            if (!isCatchThiefActive.value) {
                isFetchingPosition.value = false;
            }
            if (typeof google === "undefined" || !google.maps) {
                warnMap("handlePositionSuccess skipped because Google Maps is unavailable");
                return;
            }
            if (!userMarker || !infoWindow) {
                warnMap("handlePositionSuccess skipped because user marker is not initialized");
                return;
            }

            alarm.setUserLocation(position);

            location.value = position;

            user = new google.maps.LatLng(
                position.coords.latitude,
                position.coords.longitude
            );

            setMarkerPosition(userMarker, user);
            setMarkerVisible(userMarker, true);

            // REPLACED: nice card + local time
            const rowsUser: Array<[string, string | number]> = [
                ["Local time", formatLocal(position.timestamp)],
                ["Latitude", user.lat().toFixed(6)],
                ["Longitude", user.lng().toFixed(6)],
            ];
            if (Number.isFinite(position.coords.accuracy)) {
                rowsUser.push([
                    "Accuracy (m)",
                    Math.round(position.coords.accuracy),
                ]);
            }
            const contentUser = infoCard("User position", rowsUser);

            setMarkerClickHandler(userMarker, () => {
                if (!infoWindow || !userMarker) {
                    warnMap("user info window click skipped because marker or info window is unavailable");
                    return;
                }
                infoWindow.close();
                infoWindow.setContent(contentUser);
                openInfoWindowAtMarker(infoWindow, userMarker);
            });
        };

        const goToGeoPerm = () => {
            if (!root || !root.$router) {
                warnMap("geo permission redirect skipped because router is unavailable");
                return;
            }

                if (root.$route?.name === "geo-permission") {
                    return;
                }

                root.$router.push({
                    name: "geo-permission",
                    query: { destination: "map" },
                }).catch((navigationError: Error & { name?: string; message?: string }) => {
                    if (navigationError?.name === "NavigationDuplicated") {
                        return;
                    }

                    if (navigationError?.message?.includes("Avoided redundant navigation")) {
                        return;
                    }

                    warnMap("geo permission redirect failed", navigationError);
                });
        };

        const handlePositionError = async (error: GeolocationPositionError) => {
            // Only hide loading if we're not in catch thief mode or if it was explicitly shown
            if (!isCatchThiefActive.value) {
                isFetchingPosition.value = false;
            }

            errorMessage.value = getGeolocationErrorMessage(error);

            const shouldRedirectToGeoPermission =
                isGeolocationPermissionDenied(error);
            const isTransientTrackingError =
                isCatchThiefActive.value && !shouldRedirectToGeoPermission;

            if (isTransientTrackingError) {
                warnMap("catch thief user position poll failed", {
                    code: error.code,
                    message: error.message,
                });
                return;
            }

            if (shouldRedirectToGeoPermission && isCatchThiefActive.value) {
                await stop_tracking();
            }

            app.error = errorMessage.value;

            if (shouldRedirectToGeoPermission) {
                goToGeoPerm();
            }
        };

        const updateShipPosition = () => {
            if (typeof google === "undefined" || !google.maps) {
                warnMap("updateShipPosition skipped because Google Maps is unavailable");
                return;
            }
            if (!shipMarker || !infoWindowBoat) {
                warnMap("updateShipPosition skipped because ship marker is not initialized");
                return;
            }
            if (lat.value != 0 && lng.value != 0) {
                ship = new google.maps.LatLng(lat.value, lng.value);

                setMarkerPosition(shipMarker, ship);

                // REPLACED: nice card + local time
                const rowsBoat: Array<[string, string | number]> = [
                    ["Local time", formatLocal(Date.now())],
                    ["Latitude", ship.lat().toFixed(6)],
                    ["Longitude", ship.lng().toFixed(6)],
                ];
                const contentBoat = infoCard("Boat position", rowsBoat);

                setMarkerClickHandler(shipMarker, () => {
                    if (!infoWindowBoat || !shipMarker) {
                        warnMap("boat info window click skipped because marker or info window is unavailable");
                        return;
                    }
                    infoWindowBoat.close();
                    infoWindowBoat.setContent(contentBoat);
                    openInfoWindowAtMarker(infoWindowBoat, shipMarker);
                });

                // Keep green (disarmed) geofence following ship
                if (!armed.value && geoFenceDisarmed) {
                    geoFenceDisarmed.setCenter(ship);
                }

                if (!alarm.trackingStatus) {
                    updateGeoFenceRadius();
                }
            }
        };

        const start_tracking = async () => {
            if (!alarm.trackingStatus) {
                const accessResolution = await resolveGeolocationAccess(TRACKING_GEOLOCATION_OPTIONS);
                console.info("[GeoTrace] Map.start_tracking resolved permission state", {
                    permissionState: accessResolution.permissionState,
                    accessStatus: accessResolution.accessStatus,
                    trackingStatus: alarm.trackingStatus,
                });

                if (accessResolution.accessStatus !== "granted") {
                    errorMessage.value = accessResolution.accessStatus === "denied"
                        ? "User denied the request for geolocation."
                        : getGeolocationUnavailableMessage();
                    app.error = errorMessage.value;
                    goToGeoPerm();
                    return;
                }

                clearTrackingTimers();
                const initialPosition = accessResolution.position
                    ? (handlePositionSuccess(accessResolution.position), accessResolution.position)
                    : await requestUserPosition(false, TRACKING_GEOLOCATION_OPTIONS);
                if (!initialPosition) {
                    return;
                }

                isCatchThiefActive.value = true;
                await alarm.catchThiefStart(20); // <� calls Particle via server
                if (userMarker) {
                    setMarkerVisible(userMarker, true);
                } else {
                    warnMap("start_tracking could not show user marker because it is not initialized");
                }
                userPositionWatchId = startWatchingPosition(
                    (position: GeolocationPosition) => {
                        handlePositionSuccess(position);
                    },
                    (error: GeolocationPositionError) => {
                        handlePositionError(error);
                    },
                    TRACKING_GEOLOCATION_OPTIONS
                );
                // Boat position polling at standard rate (10 seconds)
                timerBoat = setInterval(() => {
                    alarm.getGeoLocation();
                }, 10000);
            }
        };

        const stop_tracking = async () => {
            clearTrackingTimers();
            isCatchThiefActive.value = false;
            // Ensure loading dialog is hidden when stopping
            isFetchingPosition.value = false;
            if (alarm.trackingStatus) {
                await alarm.catchThiefStop(); // <� tells Particle to stop + flips UI off
                if (userMarker) {
                    setMarkerVisible(userMarker, false);
                } else {
                    warnMap("stop_tracking could not hide user marker because it is not initialized");
                }
            }
        };

        const saveGeofence = async () => {
            await profilestore.Update(profile.value);
            if (geoFence) {
                geoFence.setRadius(profile.value.geofenceRadius);
            } else {
                warnMap("saveGeofence skipped armed geofence radius update because it is not initialized");
            }
            if (geoFenceDisarmed) {
                geoFenceDisarmed.setRadius(profile.value.geofenceRadius);
            } else {
                warnMap("saveGeofence skipped disarmed geofence radius update because it is not initialized");
            }
            unsavedGeofenceRadius = profile.value.geofenceRadius;
            updateGeoFenceRadius();
            showDialog.value = false;
        };

        const showGeofenceDialog = () => {
            profile.value.geofenceRadius = unsavedGeofenceRadius;
            if (profile.value.geofenceSirenEnabled === undefined || profile.value.geofenceSirenEnabled === null) {
                profile.value.geofenceSirenEnabled = true;
            }
            updateGeoFenceRadius();
            showDialog.value = true;
        };

        const closeGeofenceDialog = () => {
            profile.value.geofenceRadius = unsavedGeofenceRadius;
            updateGeoFenceRadius();
            showDialog.value = false;
        };

        /*
             Zoom level 16 = 160 - 250
             Zoom level 17 = 80 - 160
             Zoom level 18 = 45 - 80
             Zoom level 19 = 25 - 45
             */
        const updateGeoFenceRadius = () => {
            if (!myGoogleMap) {
                warnMap("updateGeoFenceRadius skipped because map is not initialized");
                return;
            }
            if (
                profile.value.geofenceRadius >= 160 &&
                profile.value.geofenceRadius <= 250
            ) {
                myGoogleMap.setZoom(16);
            } else if (
                profile.value.geofenceRadius >= 80 &&
                profile.value.geofenceRadius < 160
            ) {
                myGoogleMap.setZoom(17);
            } else if (
                profile.value.geofenceRadius >= 45 &&
                profile.value.geofenceRadius < 80
            ) {
                myGoogleMap.setZoom(18);
            } else if (
                profile.value.geofenceRadius >= 25 &&
                profile.value.geofenceRadius < 45
            ) {
                myGoogleMap.setZoom(19);
            }

            if (geoFence) {
                geoFence.setRadius(profile.value.geofenceRadius);
                const center = geoFence.getCenter() ?? new google.maps.LatLng(
                    profile.value.geofenceLatitude,
                    profile.value.geofenceLongitude
                );
                if (center) {
                    myGoogleMap.setCenter(center);
                }
            } else {
                warnMap("updateGeoFenceRadius skipped armed geofence update because circle is not initialized");
            }

            if (geoFenceDisarmed) {
                geoFenceDisarmed.setRadius(profile.value.geofenceRadius);
                const center = geoFenceDisarmed.getCenter() ?? new google.maps.LatLng(
                    lat.value,
                    lng.value
                );
                if (center) {
                    myGoogleMap.setCenter(center);
                }
            } else {
                warnMap("updateGeoFenceRadius skipped disarmed geofence update because circle is not initialized");
            }
        };

        const updateGeoFenceVisible = () => {
            if (geoFenceDisarmed) {
                geoFenceDisarmed.setVisible(showGeofence.value);
            }
        };

        const armed = computed<boolean>(() => {
            return alarm.armed;
        });

        const isLoading = computed<boolean>(() => {
            return alarm.trackingStatus;
        });

        watch(geoFenceRadius, (newRadius, oldRadius) => {
            if (newRadius === oldRadius) {
                return;
            }

            updateGeoFenceRadius();
        });

        const refreshGeofenceLock = async () => {
            await profilestore.Get(); // fetch latest from DB
            if (typeof google === "undefined" || !google.maps) {
                warnMap("refreshGeofenceLock skipped because Google Maps is unavailable");
                return;
            }
            const lock = new google.maps.LatLng(
                profile.value.geofenceLatitude,
                profile.value.geofenceLongitude
            );
            if (geoFence) {
                geoFence.setCenter(lock);
                geoFence.setVisible(true);
            }
            if (geoFenceDisarmed) geoFenceDisarmed.setVisible(false);
            if (myGoogleMap) myGoogleMap.setCenter(lock);
        };

        onMounted(async () => {
            window.addEventListener("mouseup", stopSlidingRadius);
            window.addEventListener("touchend", stopSlidingRadius);
            window.addEventListener("touchcancel", stopSlidingRadius);
            patchIntersectionObserver();

            await alarm.getGeoLocation(); // hydrate lat/lng once on load
            await nextTick();
            profilestore.Get();
            googleMapApi.load().then(() => {
                if (typeof google === "undefined" || !google.maps) {
                    warnMap("Google Maps API reported loaded, but google.maps is unavailable");
                    return;
                }
                const mapElement = map.value as HTMLElement | undefined;
                if (!(mapElement instanceof HTMLElement) || !mapElement.isConnected) {
                    warnMap("map initialization skipped because map container ref is unavailable");
                    return;
                }
                console.log("Google Maps API loaded");
                const markerPos = new google.maps.LatLng(lat.value, lng.value);
                const geofencePos = new google.maps.LatLng(
                    geofence_lat.value,
                    geofence_lon.value
                );
                const userPos = new google.maps.LatLng(
                    user_lat.value,
                    user_lng.value
                );
                infoWindow = new google.maps.InfoWindow();
                infoWindowBoat = new google.maps.InfoWindow();

                shipIcon = {
                    url: "https://dsspoc.azurewebsites.net/img/icons/map-marker-device.svg",
                    width: 80,
                    height: 80,
                    alt: profile.value.shipName || "Ship",
                };

                userIcon = {
                    url: "https://dsspoc.azurewebsites.net/img/icons/map-marker-user.svg",
                    width: 80,
                    height: 80,
                    alt: "You are here.",
                };

                try {
                    myGoogleMap = new google.maps.Map(mapElement, {
                        center: markerPos,
                        mapTypeId: "satellite",
                        zoom: 16,
                        disableDefaultUI: true,
                        zoomControl: false,
                        backgroundColor: "#000000",
                        mapTypeControl: true,
                        mapTypeControlOptions: {
                            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                        },
                        mapId: GOOGLE_MAP_ID,
                        fullscreenControl: true,
                    });
                } catch (error) {
                    warnMap("map initialization failed", error);
                    return;
                }

                shipMarker = createAdvancedMarker({
                    position: markerPos,
                    title: profile.value.shipName,
                    icon: shipIcon,
                    clickable: true,
                });

                userMarker = createAdvancedMarker({
                    position: userPos,
                    icon: userIcon,
                    title: "You are here.",
                    visible: false,
                    clickable: true,
                });

                geoFence = new google.maps.Circle({
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#FF0000",
                    fillOpacity: 0.35,
                    map: myGoogleMap,
                    center: geofencePos,
                    radius: geoFenceRadius.value,
                    zIndex: 10,
                    visible: false,
                });
                geoFenceDisarmed = new google.maps.Circle({
                    strokeColor: "#00FF00",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "#00FF00",
                    fillOpacity: 0.35,
                    map: myGoogleMap,
                    center: markerPos,
                    radius: geoFenceRadius.value,
                    zIndex: 10,
                    visible: showGeofence.value,
                });
                toggle(alarm.armed);
                updateShipPosition();
                unsavedGeofenceRadius = profile.value.geofenceRadius;
                updateGeoFenceRadius();
            }).catch((error) => {
                warnMap("Google Maps API failed to load", error);
            });
        });

        onBeforeUnmount(() => {
            cleanupPageResources();
        });

        onUnmounted(() => {
            cleanupPageResources();
        });

        watch(armed, async (isArmed, wasArmed) => {
            if (isArmed && !wasArmed) {
                await refreshGeofenceLock();
            } else if (!isArmed && wasArmed) {
                if (geoFence) geoFence.setVisible(false);
                if (geoFenceDisarmed)
                    geoFenceDisarmed.setVisible(showGeofence.value);
            }
        });

        // keep boat position synced whenever alarm.lat/alarm.lng change
        watch([lat, lng], ([newLat, newLng]) => {
            if (typeof google === "undefined" || !google.maps) {
                warnMap("lat/lng watch skipped because Google Maps is unavailable");
                return;
            }
            if (!shipMarker) {
                warnMap("lat/lng watch skipped because ship marker is not initialized");
                return;
            }
            if (!newLat || !newLng) return;

            const pos = new google.maps.LatLng(newLat, newLng);
            setMarkerPosition(shipMarker, pos);

            // keep disarmed geofence following the boat
            if (!armed.value && geoFenceDisarmed) {
                geoFenceDisarmed.setCenter(pos);
            }
        });

        // This ensures the UI cleans up even if the auto-stop fired from the store
        watch(isLoading, (on) => {
            if (!on) {
                clearTrackingTimers();
                isCatchThiefActive.value = false;
                isFetchingPosition.value = false;
                if (userMarker) setMarkerVisible(userMarker, false);
            }
        });

        stopArmedWatch = alarm.$watch((module) => module.armed, toggle);
        stopLastKnownLocationWatch = alarm.$watch((module) => module.lastKnownLocation, updateShipPosition);
        return {
            armed,
            map,
            geoFence,
            geoFenceDisarmed,
            latLetter,
            lngLetter,
            start_tracking,
            stop_tracking,
            isLoading,
            showGeofenceDialog,
            closeGeofenceDialog,
            profile,
            showDialog,
            isSlidingRadius,
            saveGeofence,
            onRadiusSliderInput,
            onRadiusSliderChange,
            updateGeoFenceRadius,
            showGeofence,
            updateGeoFenceVisible,
            updateShipPosition,
            isFetchingPosition,
        };
    },
    created: function () {
        this.$once("hook:beforeDestroy", () => {
            alarm.stopTracking();
        });
    },
    data: () => ({
        fab: false,
        fab2: false,
        hover: false,
        transition: "fade-transition",
        direction: "top",
        showTTs: true,
        showThief: true,
        showSettings: true,
    }),
});
</script>

<style lang="scss" scoped>
.v-speed-dial {
    position: absolute;
}

.v-btn--floating {
    position: relative;
}

.map-style {
    height: 100%;
    overflow: visible !important;
}

.logo-on-top {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
}

.geofence-slider-only .v-card__text {
    padding-bottom: 16px !important;
}

.geofence-slider-only {
    background: transparent !important;
    box-shadow: none !important;
}

::v-deep .geofence-dialog--sliding,
::v-deep .geofence-dialog--sliding .v-card {
    background: transparent !important;
    box-shadow: none !important;
}

.geofence-slider-only .text-caption,
.geofence-slider-only .slider-label {
    color: #ffffff !important;
}

.geofence-slider-only .slider-label {
    display: inline-block;
    min-width: 88px;
    text-align: right;
    opacity: 1 !important;
    visibility: visible !important;
}

.geofence-slider-only ::v-deep .v-icon,
.geofence-slider-only ::v-deep .v-slider__thumb-label,
.geofence-slider-only ::v-deep .v-input__append-outer,
.geofence-slider-only ::v-deep .v-input__slot,
.geofence-slider-only ::v-deep .v-slider__thumb-label * {
    color: #ffffff !important;
    opacity: 1 !important;
}
/* Remove Google InfoWindow�s default white bubble/chrome */
::v-deep .gm-style .gm-style-iw-c {
    background: transparent !important;
    padding: 0 !important;
    box-shadow: none !important;
    border-radius: 12px !important; /* matches your card */
}

::v-deep .gm-style .gm-style-iw-d {
    overflow: visible !important; /* avoids inner scrollbars cutting edges */
    padding: 0 !important;
    background: transparent !important;
}

/* Hide the little white pointer (�tail�). Comment out if you want to keep it */
::v-deep .gm-style .gm-style-iw-t::after,
::v-deep .gm-style .gm-style-iw-t::before {
    display: none !important;
}

/* Nudge the default InfoWindow close button */
::v-deep .gm-style .gm-ui-hover-effect {
    top: 34px !important; /* push it DOWN a touch */
    right: 0px !important; /* move it a bit further RIGHT (closer to edge) */
    width: 28px !important;
    height: 28px !important;
    background: transparent !important;
    border-radius: 8px !important;
    box-shadow: none !important;
}

/* Keep the icon centered and white */
::v-deep .gm-style .gm-ui-hover-effect span {
    margin: 0 !important;
    width: 18px !important;
    height: 18px !important;
    background-color: #fff !important; /* the �X� color */
    opacity: 0.95;
}

::v-deep .gm-style .gm-ui-hover-effect img {
    width: 16px !important;
    height: 16px !important;
    filter: invert(1) brightness(2); /* make it white for dark header */
    opacity: 0.9;
}
</style>
